import Head from "next/head";

import {
  getSellerByUrlKey,
  getSellerCategories,
  getSellerReviewsSummary,
} from "@store/sellers/actions";
import SellerInfo from "@components/Seller/SellerInfo";
import SellerTabs from "@components/Seller/SellerTabs";
import SellerProducts from "@components/Seller/SellerProducts";
import ErrorPage from "@containers/ErrorPage";

const SellerPage = ({ seller, categories, reviewsSummary }) => {
  if (!seller) {
    return <ErrorPage layout="404" />;
  }

  return (
    <>
      <Head>
        <title>{seller.name}</title>
      </Head>

      <div className="mt-[36px]">
        <SellerInfo seller={seller} />
        <SellerTabs seller={seller} reviewsSummary={reviewsSummary} />

        {categories?.length > 0 && (
          <SellerProducts seller={seller} categories={categories} />
        )}
      </div>

      <style global jsx>{`
        html {
          scroll-behavior: smooth;
          scroll-padding-top: 1rem;
          overflow-anchor: none;
        }
      `}</style>
    </>
  );
};

SellerPage.pageLayout = "default";

SellerPage.getInitialProps = async (ctx) => {
  const {
    query: { vendorUrlKey },
    reduxStore,
  } = ctx;

  const seller = await reduxStore.dispatch(getSellerByUrlKey(vendorUrlKey));

  // if seller is undefind we return it to show 404 page
  if (!seller) return null;

  const categories = await reduxStore.dispatch(getSellerCategories(seller.id));

  const reviewsSummary = ![1, 2].includes(seller.id)
    ? await reduxStore.dispatch(getSellerReviewsSummary(seller.id))
    : null;

  return {
    vendorUrlKey,
    seller,
    categories,
    reviewsSummary,
  };
};

export default SellerPage;
